"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBaseTable = _interopRequireWildcard(require("react-base-table"));

var _utils = require("react-base-table/lib/utils");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseScope = _interopRequireDefault(require("../utils/baseScope"));

var _excluded = ["columns", "children", "selectable", "selectionColumnProps"],
    _excluded2 = ["columns", "data"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var generateColumns = _baseScope["default"].generateColumns,
    generateData = _baseScope["default"].generateData,
    action = _baseScope["default"].action;
var StyledTable = (0, _styledComponents["default"])(_reactBaseTable["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .row-selected {\n    background-color: #e3e3e3;\n  }\n"])));

var ResetSelectionCell = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ResetSelectionCell, _React$PureComponent);

  var _super = _createSuper(ResetSelectionCell);

  function ResetSelectionCell() {
    var _this;

    _classCallCheck(this, ResetSelectionCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleChange", function (e) {
      var _this$props = _this.props,
          rowData = _this$props.rowData,
          rowIndex = _this$props.rowIndex,
          column = _this$props.column;
      var onChange = column.onChange;
      onChange({
        selected: e.target.checked,
        rowData: rowData,
        rowIndex: rowIndex
      });
    });

    return _this;
  }

  _createClass(ResetSelectionCell, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          column = _this$props2.column,
          onClick = _this$props2.onClick;
      var selectedRowKeys = column.selectedRowKeys;
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        checked: selectedRowKeys && selectedRowKeys.length > 0,
        onClick: onClick,
        readOnly: true
      });
    }
  }]);

  return ResetSelectionCell;
}(_react["default"].PureComponent);

var SelectionCell = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(SelectionCell, _React$PureComponent2);

  var _super2 = _createSuper(SelectionCell);

  function SelectionCell() {
    var _this2;

    _classCallCheck(this, SelectionCell);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "_handleChange", function (e) {
      var _this2$props = _this2.props,
          rowData = _this2$props.rowData,
          rowIndex = _this2$props.rowIndex,
          column = _this2$props.column;
      var onChange = column.onChange;
      onChange({
        selected: e.target.checked,
        rowData: rowData,
        rowIndex: rowIndex
      });
    });

    return _this2;
  }

  _createClass(SelectionCell, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          rowData = _this$props3.rowData,
          column = _this$props3.column;
      var selectedRowKeys = column.selectedRowKeys,
          rowKey = column.rowKey;
      var checked = selectedRowKeys.includes(rowData[rowKey]);
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        checked: checked,
        onChange: this._handleChange
      });
    }
  }]);

  return SelectionCell;
}(_react["default"].PureComponent);

var SelectableTable = /*#__PURE__*/function (_React$PureComponent3) {
  _inherits(SelectableTable, _React$PureComponent3);

  var _super3 = _createSuper(SelectableTable);

  function SelectableTable(props) {
    var _this3;

    _classCallCheck(this, SelectableTable);

    _this3 = _super3.call(this, props);

    _defineProperty(_assertThisInitialized(_this3), "_handleSelectChange", function (_ref) {
      var selected = _ref.selected,
          rowData = _ref.rowData,
          rowIndex = _ref.rowIndex;

      var selectedRowKeys = _toConsumableArray(_this3.state.selectedRowKeys);

      var key = rowData[_this3.props.rowKey];

      if (selected) {
        if (!selectedRowKeys.includes(key)) selectedRowKeys.push(key);
      } else {
        var index = selectedRowKeys.indexOf(key);

        if (index > -1) {
          selectedRowKeys.splice(index, 1);
        }
      } // if `selectedRowKeys` is uncontrolled, update internal state


      if (_this3.props.selectedRowKeys === undefined) {
        _this3.setState({
          selectedRowKeys: selectedRowKeys
        });
      }

      _this3.props.onRowSelect({
        selected: selected,
        rowData: rowData,
        rowIndex: rowIndex
      });

      _this3.props.onSelectedRowsChange(selectedRowKeys);
    });

    _defineProperty(_assertThisInitialized(_this3), "_rowClassName", function (_ref2) {
      var rowData = _ref2.rowData,
          rowIndex = _ref2.rowIndex;
      var _this3$props = _this3.props,
          rowClassName = _this3$props.rowClassName,
          rowKey = _this3$props.rowKey;
      var selectedRowKeys = _this3.state.selectedRowKeys;
      var rowClass = rowClassName ? (0, _utils.callOrReturn)(rowClassName, {
        rowData: rowData,
        rowIndex: rowIndex
      }) : "";
      var key = rowData[rowKey];
      return [rowClass, selectedRowKeys.includes(key) && "row-selected"].filter(Boolean).concat(" ");
    });

    var _selectedRowKeys = props.selectedRowKeys,
        defaultSelectedRowKeys = props.defaultSelectedRowKeys,
        expandedRowKeys = props.expandedRowKeys,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys;
    _this3.state = {
      selectedRowKeys: (_selectedRowKeys !== undefined ? _selectedRowKeys : defaultSelectedRowKeys) || [],
      expandedRowKeys: (expandedRowKeys !== undefined ? expandedRowKeys : defaultExpandedRowKeys) || []
    };
    return _this3;
  }
  /**
   * Set `selectedRowKeys` manually.
   * This method is available only if `selectedRowKeys` is uncontrolled.
   *
   * @param {array} selectedRowKeys
   */


  _createClass(SelectableTable, [{
    key: "setSelectedRowKeys",
    value: function setSelectedRowKeys(selectedRowKeys) {
      // if `selectedRowKeys` is controlled
      if (this.props.selectedRowKeys !== undefined) return;
      this.setState({
        selectedRowKeys: (0, _utils.cloneArray)(selectedRowKeys)
      });
    }
    /**
     * See BaseTable#setExpandedRowKeys
     */

  }, {
    key: "setExpandedRowKeys",
    value: function setExpandedRowKeys(expandedRowKeys) {
      // if `expandedRowKeys` is controlled
      if (this.props.expandedRowKeys !== undefined) return;
      this.setState({
        expandedRowKeys: (0, _utils.cloneArray)(expandedRowKeys)
      });
    }
    /* some other custom methods and proxy methods */

    /**
     * Remove rowKeys from inner state  manually, it's useful to purge dirty state after rows removed.
     * This method is available only if `selectedRowKeys` or `expandedRowKeys` is uncontrolled.
     *
     * @param {array} rowKeys
     */

  }, {
    key: "removeRowKeysFromState",
    value: function removeRowKeysFromState(rowKeys) {
      if (!Array.isArray(rowKeys)) return;
      var state = {};

      if (this.props.selectedRowKeys === undefined && this.state.selectedRowKeys.length > 0) {
        state.selectedRowKeys = this.state.selectedRowKeys.filter(function (key) {
          return !rowKeys.includes(key);
        });
      }

      if (this.props.expandedRowKeys === undefined && this.state.expandedRowKeys.length > 0) {
        state.expandedRowKeys = this.state.expandedRowKeys.filter(function (key) {
          return !rowKeys.includes(key);
        });
      }

      if (state.selectedRowKeys || state.expandedRowKeys) {
        this.setState(state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props4 = this.props,
          columns = _this$props4.columns,
          children = _this$props4.children,
          selectable = _this$props4.selectable,
          selectionColumnProps = _this$props4.selectionColumnProps,
          rest = _objectWithoutProperties(_this$props4, _excluded);

      var selectedRowKeys = this.state.selectedRowKeys; // you'd better memoize this operation

      var _columns = columns || (0, _reactBaseTable.normalizeColumns)(children);

      if (selectable) {
        var selectionColumn = _objectSpread(_objectSpread({
          width: 40,
          flexShrink: 0,
          resizable: false,
          frozen: _reactBaseTable.Column.FrozenDirection.LEFT,
          cellRenderer: SelectionCell
        }, selectionColumnProps), {}, {
          key: "__selection__",
          rowKey: this.props.rowKey,
          selectedRowKeys: selectedRowKeys,
          onChange: this._handleSelectChange,
          headerRenderer: function headerRenderer(props) {
            return /*#__PURE__*/_react["default"].createElement(ResetSelectionCell, _extends({}, props, {
              onClick: function onClick() {
                if (selectedRowKeys && selectedRowKeys.length > 0) {
                  _this4.removeRowKeysFromState(selectedRowKeys);

                  _this4.props.onSelectedRowsChange([]);
                } else {
                  // select all
                  var selected = _this4.props.data.map(function (v) {
                    return v[_this4.props.rowKey];
                  });

                  _this4.setState({
                    selectedRowKeys: selected
                  });

                  _this4.props.onSelectedRowsChange(selected);
                }
              }
            }));
          }
        });

        _columns = [selectionColumn].concat(_toConsumableArray(_columns));
      }

      return /*#__PURE__*/_react["default"].createElement(StyledTable, _extends({}, rest, {
        columns: _columns,
        rowClassName: this._rowClassName
      }));
    }
  }]);

  return SelectableTable;
}(_react["default"].PureComponent);

SelectableTable.defaultProps = _objectSpread(_objectSpread({}, _reactBaseTable["default"].defaultProps), {}, {
  onRowSelect: _utils.noop,
  onSelectedRowsChange: _utils.noop
}); // Use case

var columns = generateColumns(10);
var data = generateData(columns, 200);

var _default = function _default(_ref3) {
  var columns = _ref3.columns,
      data = _ref3.data,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(SelectableTable // width={700}
  // height={400}
  // selectable
  , _extends({
    columns: columns,
    data: data // onRowSelect={action("onRowSelect")}
    // onSelectedRowsChange={action("onSelectedRowsChange")}

  }, props));
};

exports["default"] = _default;